import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const FacebookIcon = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/Icon" {...props}>
      <g clipPath="url(#clip0_2375_5867)">
        <path
          d="M22.6754 24.0001C23.4068 24.0001 24 23.407 24 22.6755V1.32459C24 0.592969 23.4068 0 22.6754 0H1.32459C0.592875 0 0 0.592969 0 1.32459V22.6755C0 23.407 0.592875 24.0001 1.32459 24.0001H22.6754Z"
          fill="#395185"
        />
        <path
          d="M16.5594 23.999V14.7049H19.6792L20.1462 11.0829H16.5594V8.77028C16.5594 7.72159 16.8507 7.00694 18.3546 7.00694L20.2726 7.00609V3.76656C19.9407 3.7224 18.8022 3.62378 17.4777 3.62378C14.7123 3.62378 12.8191 5.31175 12.8191 8.41169V11.0829H9.69141V14.7049H12.8191V23.999H16.5594Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2375_5867">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
};
